import * as Sentry from '@sentry/react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { Route as RoutePath } from '@/constants';

import {
  AppPage,
  CompanySettingsPage,
  MyOffers,
  MyOpportunities,
  Opportunities,
  Opportunity,
  PlanSettingsPage,
  ProfileSettingsPage,
  Service,
  Services,
  TeamSettingsPage,
  Prices,
  Transactions,
  MyOpportunityView,
} from './app';
import { Offer } from './app/offer/offer';
import { AuthPage, SignInPage, SignUpInvitationPage, SignUpPage, VerifyAccountPage } from './auth';
import { RecoveryPasswordPage, RecoveryPasswordSuccessPage, ResetPasswordPage } from './auth/password';
import { ForbiddenPage } from './forbidden';
import { LegalPage, PrivacyPolicy, TermsAndConditions } from './legal';
import { NotFoundPage } from './not-found';
import { UserSidebar } from '@/features/users/components/sidebar';
import { LegacyMyOpportunityRedirect } from './legacy';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export function Router() {
  return (
    <BrowserRouter basename="/">
      <SentryRoutes>
        <Route path="auth" element={<AuthPage />}>
          <Route path={RoutePath.SignIn} element={<SignInPage />} />
          <Route path={RoutePath.SignUp} element={<SignUpPage />} />
          <Route path={RoutePath.InvitationSignUp} element={<SignUpInvitationPage />} />
          <Route path={RoutePath.RecoveryPassword} element={<RecoveryPasswordPage />} />
          <Route path={RoutePath.RecoveryPasswordSuccess} element={<RecoveryPasswordSuccessPage />} />
          <Route path={RoutePath.ResetPassword} element={<ResetPasswordPage />} />
          <Route path={RoutePath.VerifyEmailAddress} element={<VerifyAccountPage />} />

          <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route element={<AppPage />}>
          <Route path={RoutePath.Home} element={<Opportunities />} />
          <Route path={RoutePath.Opportunity} element={<Opportunity />} />

          <Route path={RoutePath.Selling} element={<MyOpportunities />} />
          <Route path={RoutePath.SellingOpportunity} element={<MyOpportunityView />} />
          <Route path={RoutePath.SellingOffer} element={<Offer mode="seller" />} />

          {/* LEGACY redirects: */}
          <Route path={RoutePath.MyOpportunities} element={<Navigate to={RoutePath.Selling} replace />} />
          <Route path={RoutePath.MyOpportunity} element={<LegacyMyOpportunityRedirect />} />

          <Route path={RoutePath.Buying} element={<MyOffers />} />
          <Route path={RoutePath.BuyingOffer} element={<Offer mode="buyer" />} />
          <Route path={RoutePath.Offer} element={<Offer mode="buyer" />} />

          <Route path={RoutePath.Services} element={<Services />} />
          <Route path={RoutePath.Service} element={<Service />} />
          <Route path={RoutePath.Prices} element={<Prices />} />
          <Route path={RoutePath.Transactions} element={<Transactions />} />

          <Route element={<UserSidebar />}>
            <Route path={RoutePath.ProfileSettings} element={<ProfileSettingsPage />} />
            <Route path={RoutePath.CompanySettings} element={<CompanySettingsPage />} />
            {/* <Route path={RoutePath.TeamSettings} element={<TeamSettingsPage />} /> */}
            <Route path={RoutePath.PlanSettings} element={<PlanSettingsPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route element={<LegalPage />}>
          <Route path={RoutePath.TermsAndConditions} element={<TermsAndConditions />} />
          <Route path={RoutePath.PrivacyPolicy} element={<PrivacyPolicy />} />

          <Route path={RoutePath.Forbidden} element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </SentryRoutes>
    </BrowserRouter>
  );
}
